<!--
  Kommerzielle Landingpage „Eierautomat kaufen“. Klassen aus dem globalen
  Design-System (content--wide, title display, btn …) + seiten-eigene ea-*.
  Animationen via .reveal (initFeatureFx, browser-only, reduced-motion-safe).
  Fokus bewusst auf den Shop gelenkt: primäre CTAs = Shop/Modelle, der
  Ratgeber-Link ist absichtlich sekundär (Textlink) gehalten.
-->
<section class="ea-hero">
  <div class="content content--wide ea-hero__grid">
    <div class="ea-hero__text reveal">
      <!-- Kleine Ei-Aufschlag-Animation (reine CSS/SVG, reduced-motion-sicher).
           Dotter = Marken-Orange (--color-secondary). Dekorativ → aria-hidden. -->
      <div class="ea-egg" aria-hidden="true">
        <svg viewBox="0 0 100 100" role="img">
          <g class="ea-egg__bottom">
            <path d="M19,54 L28,49 L36,56 L46,49 L54,56 L64,49 L72,56 L81,54
                     C82,72 68,92 50,92 C32,92 18,72 19,54 Z" />
          </g>
          <g class="ea-egg__yolk">
            <circle cx="50" cy="62" r="13" class="ea-egg__yolk-fill" />
            <ellipse cx="45" cy="57" rx="5" ry="3.4" class="ea-egg__yolk-shine" />
          </g>
          <g class="ea-egg__top">
            <path d="M19,54 C18,34 32,8 50,8 C68,8 82,34 81,54
                     L72,56 L64,49 L54,56 L46,49 L36,56 L28,49 L19,54 Z" />
          </g>
        </svg>
      </div>
      <span class="ea-eyebrow" i18n="@@eier.hero.eyebrow">Direktvermarktung · 24/7</span>
      <h1 class="title display" i18n="@@eier.hero.h1">Eierautomat kaufen</h1>
      <div class="line"></div>
      <p class="ea-lead" i18n="@@eier.hero.lead">
        Verkaufe frische Eier rund um die Uhr – ganz ohne Ladenöffnungszeiten und zusätzliches Personal.
        Die <span class="tm">marktbox</span> ist dein Eierautomat für die regionale Direktvermarktung:
        bargeldlos, app-gesteuert und wetterfest im Einsatz.
      </p>
      <div class="ea-cta">
        <a class="btn btn-primary ea-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@eier.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="ea-cta__ghost" href="#preise" (click)="scrollTo($event, 'preise')" i18n="@@eier.hero.ctaAnchor">Kaufen oder mieten? ↓</a>
      </div>
    </div>
    <figure class="ea-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Eierautomat für die Direktvermarktung frischer Eier" i18n-alt="@@eier.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="ea-hero__badge" i18n="@@eier.hero.badge">🥚 frisch &amp; regional</span>
    </figure>
  </div>
</section>

<!-- ===== Vorteile ===== -->
<section class="ea-section">
  <div class="content content--wide">
    <h2 class="ea-h2 reveal" i18n="@@eier.adv.h2">Warum die marktbox als Eierautomat?</h2>
    <div class="ea-grid">
      <div class="ea-card reveal">
        <span class="ea-card__ico">🕒</span>
        <h3 i18n="@@eier.adv1.h3">24/7 Eier verkaufen</h3>
        <p i18n="@@eier.adv1.p">Deine Kundschaft holt sich frische Eier, wann sie will – auch abends, sonntags und feiertags.</p>
      </div>
      <div class="ea-card reveal">
        <span class="ea-card__ico">💳</span>
        <h3 i18n="@@eier.adv2.h3">Bargeldlos &amp; app-gesteuert</h3>
        <p i18n="@@eier.adv2.p">Kartenzahlung am Automaten, Fernwartung und Füllstände per App – ohne täglichen Aufwand vor Ort.</p>
      </div>
      <div class="ea-card reveal">
        <span class="ea-card__ico">🧩</span>
        <h3 i18n="@@eier.adv3.h3">24 oder 39 Fächer</h3>
        <p i18n="@@eier.adv3.p">Wähle das Modell passend zu deiner Menge und erweitere flexibel, wenn die Nachfrage wächst.</p>
      </div>
      <div class="ea-card reveal">
        <span class="ea-card__ico">🚜</span>
        <h3 i18n="@@eier.adv4.h3">Regionale Direktvermarktung</h3>
        <p i18n="@@eier.adv4.p">Verkaufe direkt ab Hof – ohne Zwischenhandel, mit voller Kontrolle über Preis und Präsentation.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Live-Link (Killer-Feature) ===== -->
<section class="ea-section ea-live">
  <div class="content content--wide ea-live__grid">
    <div class="ea-live__text reveal">
      <span class="ea-eyebrow" i18n="@@eier.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="ea-h2" i18n="@@eier.live.h2">Sieh, was gerade in der Box ist</h2>
      <p class="ea-lead" i18n="@@eier.live.lead">
        Jede marktbox hat ihren eigenen Live-Link: Deine Kundschaft sieht in Echtzeit, wie viele
        frische Eier gerade verfügbar sind – noch bevor sie losfährt. Das schafft Vertrauen,
        spart unnötige Wege und bringt mehr Verkäufe.
      </p>
      <ul class="ea-live__list">
        <li i18n="@@eier.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@eier.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@eier.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="ea-cta">
        <a class="btn btn-primary ea-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@eier.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Kempershof: Echtzeit-Verfügbarkeit der Eier-Box" i18n-title="@@eier.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@eier.live.cap">Live-Beispiel: Kempershof</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise / Kaufen oder mieten ===== -->
<section id="preise" class="ea-section ea-section--muted">
  <div class="content content--wide">
    <h2 class="ea-h2 reveal" i18n="@@eier.price.h2">Eierautomat kaufen oder mieten</h2>
    <div class="ea-price-grid">
      <div class="ea-price reveal">
        <span class="ea-price__label" i18n="@@eier.price.buyLabel">Kaufen</span>
        <span class="ea-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@eier.price.buyText">Einmalige Investition, dauerhaft dein Automat – ideal für den langfristigen Betrieb.</p>
      </div>
      <div class="ea-price reveal">
        <span class="ea-price__label" i18n="@@eier.price.rentLabel">Mieten</span>
        <span class="ea-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@eier.price.rentText">Niedrige Einstiegshürde, planbare monatliche Kosten – ideal zum Starten und Testen.</p>
      </div>
    </div>
    <div class="ea-cta ea-cta--center reveal">
      <a class="btn btn-primary ea-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@eier.price.cta">Zum Shop – Eierautomat konfigurieren</a>
    </div>
    <p class="ea-fineprint reveal" i18n="@@eier.price.fine">
      Noch unsicher?
      <a [routerLink]="['/', links.blog, blogEier]">Im Ratgeber: Lohnt sich ein Eierautomat?</a>
    </p>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="ea-section">
  <div class="content content--wide">
    <h2 class="ea-h2 reveal" i18n="@@eier.mod.h2">Passende Modelle</h2>
    <div class="ea-models">
      <a class="ea-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="ea-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Eierautomat mit 39 Fächern" i18n-alt="@@eier.mod39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="ea-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@eier.mod39.text">39 Fächer – für höhere Stückzahlen und mehrere Produkte neben Eiern.</p>
          <span class="ea-model__more" i18n="@@eier.mod39.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="ea-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="ea-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Eierautomat mit 24 Fächern" i18n-alt="@@eier.mod24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="ea-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@eier.mod24.text">24 Fächer – kompakter Einstieg für die Direktvermarktung ab Hof.</p>
          <span class="ea-model__more" i18n="@@eier.mod24.more">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== Praxis-Band (Direktvermarkter) ===== -->
<section class="ea-band reveal">
  <div class="content content--wide ea-band__grid">
    <figure class="ea-band__media">
      <img src="assets/slides/testimonial-01.webp" alt="Direktvermarkter verkauft regionale Produkte über die marktbox" i18n-alt="@@eier.band.imgAlt"
        width="1200" height="800" loading="lazy" />
    </figure>
    <div class="ea-band__text">
      <h2 class="ea-h2" i18n="@@eier.band.h2">Vom Hof direkt zur Kundschaft</h2>
      <p i18n="@@eier.band.p">
        Ob Eier, Kartoffeln oder weitere Hofprodukte: Mit der marktbox verkaufst du regional, rund um die Uhr
        und ohne Personal vor Ort. Finde im Shop das passende Modell und starte in wenigen Schritten.
      </p>
      <a class="btn btn-primary" [routerLink]="['/', links.shop]" i18n="@@eier.band.cta">Jetzt Modelle vergleichen</a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="ea-section ea-section--muted">
  <div class="content content--wide">
    <h2 class="ea-h2 reveal" i18n="@@eier.faq.h2">Häufige Fragen zum Eierautomat</h2>
    <div class="ea-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="ea-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
    <p class="ea-fineprint reveal" i18n="@@eier.faq.fine">
      Mehr Praxiswissen im Ratgeber:
      <a [routerLink]="['/', links.blog, blogEier]">Eier aus dem Automaten</a>.
    </p>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="ea-section ea-final reveal">
  <div class="content content--wide">
    <h2 class="ea-h2" i18n="@@eier.final.h2">Bereit für deinen Eierautomaten?</h2>
    <p class="ea-lead" i18n="@@eier.final.lead">Finde dein Modell, wähle kaufen oder mieten und starte in die Direktvermarktung.</p>
    <div class="ea-cta ea-cta--center">
      <a class="btn btn-primary ea-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@eier.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
